// extracted by mini-css-extract-plugin
export default {"control-title-block":"controls_control-title-block__1Doc9","buttons":"controls_buttons__gBHyS"};